export function OutlineCostoClienteIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8985 5.64028C18.2976 4.93014 17.4031 4.47266 16.3993 4.47266C14.583 4.47266 13.1082 5.94755 13.1082 7.76385C13.1082 9.58015 14.583 11.055 16.3993 11.055C17.4645 11.055 18.4 10.5429 19.0077 9.75768"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M23.3569 23.2501V18.1221C23.3569 16.2375 21.8274 14.7148 19.9497 14.7148H12.7664C10.8818 14.7148 9.35913 16.2444 9.35913 18.1221V23.2501"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M13.1147 19.8359V23.25"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M19.9429 19.8359V23.25"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M3.90332 0V2.77908"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M3.90332 10.209V12.9881"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M7.08542 3.47517C6.77815 3.33861 6.33431 3.16791 5.79489 3.02451C5.16669 2.86064 4.5863 2.71042 3.90348 2.77187C3.56207 2.79918 1.99158 2.94258 1.55458 4.04192C1.3907 4.46526 1.39753 5.01152 1.64334 5.4417C2.03255 6.12452 2.89973 6.31571 3.90348 6.54104C4.82528 6.74588 5.18718 6.66394 5.73343 7.04632C5.93145 7.18971 6.31383 7.46284 6.46405 7.96813C6.6211 8.48707 6.44357 8.94456 6.3548 9.11526C6.15678 9.53178 5.83586 9.75029 5.69246 9.84588C5.14621 10.2078 4.59312 10.2078 3.89665 10.1941C2.83145 10.1805 2.00524 9.91416 1.48629 9.73663C1.02198 9.57958 0.646427 9.41571 0.380127 9.28597"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
}
